export default __webpack_public_path__ + "static/media/eth.5da5daa5.svg";